import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Shell } from '@/components/chrome/Shell';
import { ProtectedRoute } from '@/components/chrome/ProtectedRoute';
import { AdminRoute } from '@/components/chrome/AdminRoute';
import { WorkspaceAdminRoute } from '@/components/chrome/WorkspaceAdminRoute';
import { LoginPage } from '@/pages/LoginPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { AccountsPage } from '@/pages/AccountsPage';
import { AccountViewPage } from '@/pages/AccountViewPage';
import { IdentitiesPage } from '@/pages/IdentitiesPage';
import { TemplatesPage } from '@/pages/TemplatesPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import { OpsPage } from '@/pages/OpsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function AppRouter() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<OverviewPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/accounts/:id" element={<AccountViewPage />} />
        {/* Temporarily disabled; keep the screen available for reactivation. */}
        <Route path="/viraux" element={<Navigate to="/" replace />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route element={<WorkspaceAdminRoute />}>
          <Route path="/identities" element={<IdentitiesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/ops" element={<OpsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
